import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../common/Button'
import classes from './CaseSummaryBox.module.css'
import { detailsActions } from '../../../../store/details'
import ItemsCounter from '../Shared/ItemsCounter'
import Tag from '../../../fragments/Tag'
import { Link } from 'react-router-dom'
import { formatDateLocalWithTime } from '../../../../lib/script'

const CaseSummaryBox = ({children, title, tabNumber, type, isPoliceReport, caseId, headerExtra}) => {
    const dispatch = useDispatch()    
    const activeCase = useSelector(state => state.case.activeCase)
    const openTabHandler = () => {
        dispatch(detailsActions.setActiveTab(tabNumber))        
    }

    return <div className={classes.item}>
        <div className={classes.item_header}>
            <div className={classes.item_title}>
                {title}
                {type && <ItemsCounter type={type}/>}
                {headerExtra}
            </div>
            {tabNumber &&<div>
                <Button btnStyle='btn_simple' click={openTabHandler} bypassisCaseArchived={true}>View All <i className="ti ti-arrow-up-right"></i></Button>
            </div>}
            {isPoliceReport && (!activeCase?.additional?.no_police_report_available || activeCase?.additional?.no_police_report_available == 0) && <div className='flex-container'>
                {isPoliceReport.is_moonbird_report_available ? <>
                    <Tag color='Green'>Available</Tag>  
                    <Link to={`/work-queues/police-report/${caseId}`} className='btn_link'>Process</Link>
                </> : <div className={classes.moonbird_info}>
                    Checked Count: {isPoliceReport.moonbird_check_count ? isPoliceReport.moonbird_check_count : 0}, Last Checked:{' '}
                    {isPoliceReport.moonbird_last_check
                        ? formatDateLocalWithTime(isPoliceReport.moonbird_last_check)
                        : 'N/A'}
                </div>} 
                
            </div>}
            
        </div>
        <div className={classes.item_body}>
            {children}
        </div>
    </div>
}

export default CaseSummaryBox